/**
 * Application constants and configuration values
 */

// Storage configuration
export const STORAGE_CONFIG = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB in bytes
  WARNING_THRESHOLD: 0.8, // 80% usage warning
  CLEANUP_TARGET: 0.5, // Cleanup to 50% of original size
  MAX_CALCULATIONS_WHEN_LOW: 10 // Keep only 10 calculations when storage is low
} as const;

// Calculation precision and limits
export const CALCULATION_CONFIG = {
  DEFAULT_PRECISION: 3,
  MAX_PRECISION: 3,
  MIN_INPUT_VALUE: -1000,
  MAX_INPUT_VALUE: 1000,
  STEP_SIZE: '0.125'
} as const;

// Special GOR range values
export const GOR_RANGE = {
  SPECIAL_MIN: -28.25,
  SPECIAL_MAX: 0
} as const;

// Default division height limits
export const DIVISION_LIMITS = {
  A_MAX_HEIGHT: 145.625,
  B_MAX_HEIGHT: 148.5,
  A_WAYSIDE_THRESHOLD: 142.3125,
  B_WAYSIDE_THRESHOLD: 145.875
} as const;

// CSV export configuration
export const CSV_CONFIG = {
  HEADERS: [
    'EQUIPMENT NAME',
    'EQUIPMENT TYPE', 
    'HEIGHT OF EQUIP. FROM T.O.R.',
    'CHART LETTER',
    'DISTANCE TO G.O.R.',
    'TRACK',
    'CENTER OR END EXCESS',
    'SUPER ELEVATION',
    'SUPER ELEV. EXCESS',
    'MIN. DISTANCE REQUIRED',
    'TOTAL CLEARANCE',
    'STATUS',
    'BALLASTED TRACK?',
    'VERTICAL CURVATURE?'
  ]
} as const;

// Fraction denominators for display formatting
export const FRACTION_DENOMINATORS = [2, 4, 8, 16] as const;

// Installation prompt delay
export const PWA_INSTALL_DELAY = 1000; // 1 second
